import { useState } from 'react';
import { faqs } from '@/mocks/siteContent';
import { SectionHead } from './kit';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="border-t border-background-200">
      <div className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <SectionHead
          index="伍"
          kicker="求证FAQ"
          title="关于五一爆料的常见疑问"
          desc="我们如何定义实锤与辟谣、怎样对待来源不明的聊天记录截图流出、结论是否持续更新——都在这份说明里。"
        />

        <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100/50"
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full font-label text-xs font-semibold ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-800'
                      }`}
                    >
                      {isOpen ? <i className="ri-subtract-line" aria-hidden="true" /> : i + 1}
                    </span>
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {f.q}
                    </span>
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-foreground-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    aria-hidden="true"
                  />
                </button>
                {isOpen ? (
                  <div className="px-5 pb-5 pl-14">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-4 rounded-lg bg-accent-100/70 px-6 py-6 sm:flex-row sm:items-center">
          <div>
            <h3 className="font-heading text-base font-bold text-accent-900">还有网传消息想求证？</h3>
            <p className="mt-1 text-sm text-accent-800">
              把来源截图与账号信息一并留言，我们会在下期台账中为你编号跟进（示意，本页不产生真实提交）。
            </p>
          </div>
          <a
            href="#top"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            回到顶部
            <i className="ri-arrow-up-line" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}